import { defaultGamerPurchaseProfile, } from 'const/gamerProfiles'
import A from 'const/actionTypes'
import actions from 'actions'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'

export default {
  addCSGOToken: (purchaseData, response) => {
    return (dispatch, getState) => {
      const counterStrikeGlobalOffensiveTokens =
        getState().currentGamerPurchaseProfile.counterStrikeGlobalOffensiveTokens || {}

      const newCounterStrikeInfo = {
        amount: parseFloat(getState().purchases.counterStrikeGlobalOffensivePackPurchaseAmount),
        createdAt: new Date(response.create_time).getTime(),
        counterStrikeGlobalOffensivePackId: getState().purchases.counterStrikeGlobalOffensivePackId,
        intent: purchaseData.intent,
        orderID: purchaseData.orderID,
        payerEmail: response.payer.payer_info.email,
        payerID: purchaseData.payerID,
        paymentID: purchaseData.paymentID,
        returnUrl: purchaseData.returnUrl,
      }
      counterStrikeGlobalOffensiveTokens[purchaseData.paymentToken] = newCounterStrikeInfo

      dispatch(actions.updateCurrentGamerPurchaseProfile({
        counterStrikeGlobalOffensiveTokens: counterStrikeGlobalOffensiveTokens
      }))
    }
  },
  addDonationToken: (purchaseData, response) => {
    return (dispatch, getState) => {
      const donations = getState().currentGamerPurchaseProfile.donations || {}

      const newDonationInfo = {
        amount: parseFloat(getState().purchases.donationAmount),
        createdAt: new Date(response.create_time).getTime(),
        intent: purchaseData.intent,
        orderID: purchaseData.orderID,
        payerEmail: response.payer.payer_info.email,
        payerID: purchaseData.payerID,
        paymentID: purchaseData.paymentID,
        returnUrl: purchaseData.returnUrl,
      }
      donations[purchaseData.paymentToken] = newDonationInfo

      dispatch(actions.updateCurrentGamerPurchaseProfile({
        donations: donations
      }))
    }
  },
  addSoundPackToken: (purchaseData, response, soundPack) => {
    return (dispatch, getState) => {
      const soundPackTokens = getState().currentGamerPurchaseProfile.soundPackTokens || {}

      const newTokenInfo = {
        amount: parseFloat(soundPack.price),
        createdAt: new Date(response.create_time).getTime(),
        intent: purchaseData.intent,
        orderID: purchaseData.orderID,
        payerEmail: response.payer.payer_info.email,
        payerID: purchaseData.payerID,
        paymentID: purchaseData.paymentID,
        returnUrl: purchaseData.returnUrl,
        soundPackId: soundPack.id,
      }
      soundPackTokens[purchaseData.paymentToken] = newTokenInfo

      dispatch(actions.updateCurrentGamerPurchaseProfile({
        soundPackTokens: soundPackTokens
      }))
    }
  },
  clearCurrentGamerPurchaseProfile: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_CURRENT_GAMER_PURCHASE_PROFILE, })
    }
  },
  createCurrentGamerPurchaseProfile: (gamerId) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.CREATE_CURRENT_GAMER_PURCHASE_PROFILE,
        defaultGamerPurchaseProfile,
      })
      firebaseService.add(
        'purchaseProfiles/',
        defaultGamerPurchaseProfile,
        N.GAMERS,
        gamerId
      )
    }
  },
  deleteCurrentGamerPurchaseProfile: (gamerId) => {
    return (dispatch, getState) => {
      firebaseService.off('purchaseProfiles/' + gamerId, N.GAMERS)
      dispatch({ type: A.DELETE_CURRENT_GAMER_PURCHASE_PROFILE, })
    }
  },
  setCurrentGamerPurchaseProfile: (gamerId) => {
    return (dispatch, getState) => {
      firebaseService.subscribe(
        'purchaseProfiles/' + gamerId,
        (result) => {
          const currentGamerPurchaseProfile = result.val() || defaultGamerPurchaseProfile
          dispatch({
            type: A.SET_CURRENT_GAMER_PURCHASE_PROFILE,
            currentGamerPurchaseProfile
          })
        },
        N.GAMERS
      )
    }
  },
  updateCurrentGamerPurchaseProfile: (newCurrentGamerPurchaseProfile) => {
    return (dispatch, getState) => {
      let gamerId = getState().auth.uid
      let currentGamerPurchaseProfile = getState().currentGamerPurchaseProfile || defaultGamerPurchaseProfile
      let updatedCurrentGamerPurchaseProfile = Object.assign(
        {}, currentGamerPurchaseProfile, newCurrentGamerPurchaseProfile
      )

      dispatch({
        type: A.UPDATE_CURRENT_GAMER_PURCHASE_PROFILE,
        updatedCurrentGamerPurchaseProfile,
      })

      firebaseService.update(
        'purchaseProfiles/' + gamerId,
        updatedCurrentGamerPurchaseProfile,
        (error) => {
          if (error) { dispatch(actions.alertGamerWithError(error)) }
        },
        N.GAMERS,
      )
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/currentGamerPurchaseProfile.js